import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { SettingsProvider } from "./context/SettingsContext";
import { AuthProvider } from "./context/AuthContext";
import DesignVars from "./components/DesignVars";

import Header from "./components/Header";
import Footer from "./components/Footer";
import StickyActions from "./components/StickyActions";
import MobileStickyCTA from "./components/MobileStickyCTA";
import EnquiryPopup from "./components/EnquiryPopup";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import Calculator from "./pages/Calculator";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import ProjectsAdmin from "./pages/admin/ProjectsAdmin";
import LeadsAdmin from "./pages/admin/LeadsAdmin";
import ServicesAdmin from "./pages/admin/ServicesAdmin";
import TestimonialsAdmin from "./pages/admin/TestimonialsAdmin";
import BlogAdmin from "./pages/admin/BlogAdmin";
import PackagesAdmin from "./pages/admin/PackagesAdmin";
import PartnersAdmin from "./pages/admin/PartnersAdmin";
import BrochuresAdmin from "./pages/admin/BrochuresAdmin";
import SettingsAdmin from "./pages/admin/SettingsAdmin";
import ContentAdmin from "./pages/admin/ContentAdmin";
import UsersAdmin from "./pages/admin/UsersAdmin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicLayout() {
  return (
    <>
      <Header />
      <main><Outlet /></main>
      <Footer />
      <StickyActions />
      <MobileStickyCTA />
      <EnquiryPopup />
    </>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <SettingsProvider>
        <DesignVars />
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/:slug" element={<ServiceDetail />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/projects/:slug" element={<ProjectDetail />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/calculator" element={<Calculator />} />
              </Route>

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="projects" element={<ProjectsAdmin />} />
                <Route path="leads" element={<LeadsAdmin />} />
                <Route path="services" element={<ServicesAdmin />} />
                <Route path="testimonials" element={<TestimonialsAdmin />} />
                <Route path="blog" element={<BlogAdmin />} />
                <Route path="packages" element={<PackagesAdmin />} />
                <Route path="partners" element={<PartnersAdmin />} />
                <Route path="brochures" element={<BrochuresAdmin />} />
                <Route path="content" element={<ContentAdmin />} />
                <Route path="users" element={<UsersAdmin />} />
                <Route path="settings" element={<SettingsAdmin />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </SettingsProvider>
    </HelmetProvider>
  );
}
